//------------ IMPORTAÇÕES ------------//
import { X } from "lucide-react";
import { useContext } from "react";
import { GruposContext } from "../../context/GruposContext";
import { loadGroupsService, deleteGroupService } from "../../services";



//------------ EXPORTAÇÃO DO MODAL CREATE GROUP ------------//
export default function ModalDeleteGroup() {



    //------------ CRIAÇÃO DE HOOKS ------------//
    const { groups, setGroups } = useContext(GruposContext);
    const { isOpenModalDeleteGroup, setIsOpenModalDeleteGroup } = useContext(GruposContext);
    const { formDataModalDeleteGroup, setFormDataModalDeleteGroup } = useContext(GruposContext);



    //--------------- FUNÇÃO ASSÍNCRONA DELETAR GRUPO ---------------//
    // Responsável por Deletar o Grupo seleciona via API
    async function handleDeleteGroup() {
        const response = await deleteGroupService(formDataModalDeleteGroup.id);
        if(response){
            handleRefreshGroups();
            setFormDataModalDeleteGroup({});
            setIsOpenModalDeleteGroup(false);
        }
    };



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS ---------------//
    // Responsável por requisitar à API os Grupos existentes
    // Armazena no Estado "grupos" a lista de Grupos retornada pela API
    async function handleRefreshGroups() {
        const response = await loadGroupsService();
        if (response) {
            setGroups(response.data);
        }
    }



    //--------------- RETORNO CONDICIONAL DO MODAL CREATE LEAD ---------------//
    return (
        <>
            {!isOpenModalDeleteGroup
                ? null
                :
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                        <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
                            <div className={"flex justify-between items-center mb-4"}>
                                <h2 className="text-xl font-bold">Você deseja excluir este grupo?</h2>
                                <button onClick={() => {
                                    setIsOpenModalDeleteGroup(false);
                                    setFormDataModalDeleteGroup({});
                                    }}><X className="text-white" /></button>
                            </div>
                            <div className="flex flex-col gap-3">
                                <div className={"flex justify-end gap-3"}>
                                    <button onClick={() => {
                                        setIsOpenModalDeleteGroup(false);
                                        setFormDataModalDeleteGroup({});
                                    }} className="px-4 py-2 bg-surface-3 rounded">Cancelar</button>
                                    <button onClick={handleDeleteGroup} className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded">Confirmar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
